import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueScrollTo from "vue-scrollto";

Vue.config.productionTip = false;

Vue.prototype.$browserBackFlg = false;
history.replaceState(null, "", null);
window.addEventListener("popstate", function () {
  Vue.prototype.$browserBackFlg = true;

  window.setTimeout(() => {
    Vue.prototype.$browserBackFlg = false;
  }, 500);
});

function mountVue(): void {
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount("#app");
  Vue.use(VueScrollTo);
}

if (process.env.VUE_APP_NODE_ENV === "local") {
  mountVue();
} else {
  mountVue();
}
